"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/objectWithoutProperties"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _react = _interopRequireDefault(require("react"));

var _StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "DownloadPowerpoint___StyledSvg",
  componentId: "sc-1nrx6q0-0"
})(["color:", ";height:", ";width:", ";font-size:", ";vertical-align:text-top;"], function (p) {
  return p._css;
}, function (p) {
  return p._css2;
}, function (p) {
  return p._css3;
}, function (p) {
  return p._css4;
});

function DownloadPowerpoint(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? null : _ref$title,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["title"]);
  return _react["default"].createElement(_StyledSvg, (0, _extends2["default"])({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    focusable: false,
    "data-wbi-icon": true
  }, props, {
    _css: props.color,
    _css2: props.size,
    _css3: props.size,
    _css4: props.size
  }), title ? _react["default"].createElement("title", null, title) : null, _react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5l-3-3H6a1 1 0 00-1 1v14a1 1 0 001 1h11a1 1 0 001-1V5zm-4-2v3h3v11H6V3h8z",
    fill: "#707070"
  }), _react["default"].createElement("rect", {
    x: 2,
    y: 6,
    width: 11,
    height: 10,
    rx: 1,
    fill: "#D44519"
  }), _react["default"].createElement("path", {
    d: "M6.945 12.07V14H5.684V8.398H7.66c1.412 0 2.117.595 2.117 1.786 0 .562-.203 1.018-.609 1.367-.404.346-.944.52-1.621.52h-.602zm0-2.703v1.746h.496c.672 0 1.008-.294 1.008-.883 0-.575-.336-.863-1.008-.863h-.496z",
    fill: "#fff"
  }));
}

var _default = DownloadPowerpoint;
exports["default"] = _default;